import React from 'react';
import styled from 'styled-components';
import { gridSize } from '@atlaskit/theme';

const PageTitle = styled.h1`
  margin-bottom: ${gridSize() * 2}px;
`;

export default ({children}) => (
  <div className="container-fluid">
    <div className="row">
      <div className="col-md-12">
        <PageTitle>
          {children}
        </PageTitle>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/PageTitle.js